import { render, staticRenderFns } from "./RenewalWelcomeStep.vue?vue&type=template&id=a2a53046&lang=pug"
import script from "./RenewalWelcomeStep.vue?vue&type=script&lang=js"
export * from "./RenewalWelcomeStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports